import React, { useState } from 'react';
import {
  DropdownIndicator,
  getTranslatedText,
  reactSelectInlineError,
  reactSelectErrorStyles
} from '@nile/components';
import { DropdownArrow } from '@nile/mangifera/src/Pebbles/select';
import Select from 'react-select';
import { SVGIcon } from '@superops/super-icons';
import { Tooltip } from 'react-clone-tippy';
import { FormattedMessage, injectIntl } from 'react-intl';

const ValueSelector = ({
  className,
  handleOnChange,
  options,
  title,
  value,
  async,
  placeholder = 'Choose property',
  isDisabled = false,
  intl,
  optionsFiltered,
  isOptionDisabled,
  errors
}) => {
  let initialOptions = async ? [] : options;
  const [_options, setOptions] = useState(initialOptions);
  if (async) {
    options.then((res) => {
      setOptions(res);
    });
  }
  let allOptions = [];
  allOptions = _options.map((item) => {
    return {
      ...item,
      value: item.name
    };
  });

  if (_options.length && _options[0]._options) {
    allOptions = _options.map((item) => {
      item._options = item._options.map((el) => {
        return {
          ...el,
          value: el.name
        };
      });
      return item;
    });
  }
  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '14'
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
    </div>
  );

  const formatOptionLabel = (props) => {
    const { name, label, template } = props;
    return template ? (
      { template }
    ) : (
      <div className="react-select-option" data-qa={name}>
        <div className="react-select-label">{label}</div>
      </div>
    );
  };

  const indicatorSeparatorStyle = {
    width: 0
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  const getSVGicon = (parentLabel) => {
    return (
      <span className="mr8">
        <Tooltip
          // title={parentLabel}
          html={
            parentLabel && (
              <div>
                {getTranslatedText(intl, 'common.admin.dependent.to')}
                {` `}
                {parentLabel}
              </div>
            )
          }
          delay={400}
          duration={250}
          position="top-start"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
        >
          <SVGIcon name="DependentField" />
        </Tooltip>
      </span>
    );
  };

  const customSingleValue = ({ data }) => {
    let parentLabel = '';
    if (data.isDependant && data.nestedTo) {
      try {
        parentLabel = options.find((el) => el.name === data.nestedTo).label;
      } catch (e) {}
    }

    return (
      <div className="flex center ptr mw-90">
        {parentLabel && getSVGicon(parentLabel)}
        <Tooltip
          // title={parentLabel}
          html={<div>{data.label}</div>}
          delay={400}
          duration={250}
          position="top-start"
          inertia
          trigger="mouseenter"
          animation="shift"
          animateFill={false}
        >
          <span className="">{data.label}</span>
        </Tooltip>
      </div>
    );
  };

  const customSingleOption = (props) => {
    const { data, innerRef, getStyles, innerProps, cx } = props;
    let parentLabel = '';
    if (data.isDependant) {
      try {
        parentLabel = options.find((el) => el.name === data.nestedTo).label;
      } catch (e) {
        console.log('Error in finding parent label', e);
      }
    }
    return (
      <div
        css={
          data?.isInactive
            ? {
                ...getStyles('option', props),
                backgroundColor: 'transparent'
              }
            : {}
        }
        className="flex center ptr p10 value_selector__option"
        ref={innerRef}
        {...innerProps}
      >
        {parentLabel && getSVGicon(parentLabel)}
        {data.label}
      </div>
    );
  };

  const getComponents = () => {
    let returnable = {
      IndicatorSeparator,
      DropdownArrow,
      SingleValue: customSingleValue,
      Option: customSingleOption
    };

    return returnable;
  };

  const dropdownOptions = optionsFiltered || allOptions;
  const val = dropdownOptions.find((el) => el.name === value);
  return (
    /**
     * set portal target to body so that the dropdown does not go inside the parent container
     */
    <div data-qa={title} className="p5">
      <Select
        className={`${className}`}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        formatOptionLabel={formatOptionLabel}
        value={val}
        key={val?.name}
        components={getComponents()}
        title={title}
        onChange={(value) => handleOnChange(value)}
        options={dropdownOptions}
        placeholder={placeholder}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
        name="valueselector"
        styles={
          errors
            ? {
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
                ...reactSelectErrorStyles
              }
            : {
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }
        }
        isDisabled={isDisabled}
        isOptionDisabled={isOptionDisabled}
      />
      {errors && reactSelectInlineError(errors[0])}
    </div>
  );
};

ValueSelector.displayName = 'ValueSelector';

export default injectIntl(ValueSelector);
